module.exports = __webpack_public_path__ + "media/icons/search@2x-29a6dcf8.png";